import Promise from 'promise'
import axios from 'axios'

const LMS_USER_API_URL = '/api'
axios.defaults.withCredentials = true

export default {
  get () {
    return new Promise((resolve, reject) => {
      axios.get(LMS_USER_API_URL + '/agreements')
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  },
  sign (agreement_id, signature_seq, signed_name) {
    return axios.post(LMS_USER_API_URL + '/agreements/' + agreement_id + '/sign', {
      sequence: signature_seq,
      name: signed_name
    })
  }
}



// WEBPACK FOOTER //
// ./src/backend-resources/agreement-resource.js